import React from "react";
import { useTranslation } from "react-i18next";
import { urls } from "../../shared/seo/links";
import "./content.css";

const NAMES = { ar: "العربية", fr: "Français", en: "English" };

/**
 * "Read in: العربية / Français / English" for a guide published in several
 * languages. Plain links: the other language is another document (its own
 * direction and stylesheet). siblings: [{ id, title, language }].
 */
export default function ReadIn({ siblings, lang }) {
  const { t } = useTranslation();
  const others = urls.LANGS.map((l) => (siblings || []).find((s) => s.language === l && l !== lang)).filter(Boolean);
  if (others.length === 0) return null;
  return (
    <p className="avc-read-in">
      <i className="fas fa-language" aria-hidden="true"></i>
      <span>{t("read_in")}</span>
      {others.map((s, i) => (
        <React.Fragment key={s.language}>
          {i > 0 && <span aria-hidden="true">/</span>}
          <a href={urls.toHref(urls.blogPath(s))} hrefLang={s.language} lang={s.language}>
            {NAMES[s.language]}
          </a>
        </React.Fragment>
      ))}
    </p>
  );
}
